import { makeStyles } from '@material-ui/styles'
import { ChevronRightRounded } from '@mui/icons-material'
import { Breadcrumbs, Button, Link, Stack, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { BsFileEarmarkArrowUp } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import { Link as RRDLink, useParams } from 'react-router-dom'
import { selectCurrrentAdminShop } from '../../../../../store/features/currentBusinessShop'

export default function Header({handleOnHeaderButtonClick}:{handleOnHeaderButtonClick: (arg?:any)=>void}) {

    const classes = useStyles()
    const currentShop = useSelector(selectCurrrentAdminShop)
    const {inventory} = useParams<any>()


    return(

        <Stack direction="row" justifyContent="space-between" alignItems="center" >
                    
            <Stack direction="column">
                <Typography variant="h6" sx={{color: "grey.200", fontWeight: "bold" }}>Shop Sales</Typography>
                <Breadcrumbs sx={{color: grey[500] }} separator={<ChevronRightRounded sx={{color: grey[500]}} />}  >
                    <Link to={`/${currentShop?.name}`} className={classes.links} component={RRDLink} >
                        {currentShop?.name}
                    </Link>
                    <Link className={classes.link_current} >
                        <span className='capitalize'>{inventory?.replaceAll(":","").replaceAll("_"," ")}</span>
                    </Link>
                </Breadcrumbs>
            </Stack>

            <Button onClick={handleOnHeaderButtonClick} className={classes.button} variant="contained" title="Settings" startIcon={<BsFileEarmarkArrowUp />} >
                Export
            </Button>
        </Stack>

    )
}

const useStyles= makeStyles(theme=>({

    button:{
        color: '#1A1B41',
        boxShadow: "none",
        backgroundColor: '#baff29',
        textTransform: "capitalize",
        '&:hover': {
            backgroundColor: '#baff29'
        },
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
    },
    links:{
        color: grey[200],
        textDecoration: "none",
        fontSize: "13px"
    },
    link_current:{
        color: grey[500],
        textDecoration: "none",
        fontSize: "13px"
    }

}))
